import React from 'react';
import { colors } from '../constants';

type Props = {
  size: string,
};

function UploadIcon({ size = '20' }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.321 7.739a1.5 1.5 0 00.912.984A3.502 3.502 0 0114 15.5H6a3.5 3.5 0 01-1.233-6.777 1.5 1.5 0 00.912-.984 4.503 4.503 0 018.642 0zM1 12a5.002 5.002 0 013.239-4.68 6.003 6.003 0 0111.522 0A5.002 5.002 0 0114 17H6a5 5 0 01-5-5zm9-4.75a.748.748 0 01.53.22l2 2a.75.75 0 11-1.06 1.06l-.72-.72V13a.75.75 0 01-1.5 0V9.81l-.72.72a.75.75 0 11-1.06-1.06l2-2a.748.748 0 01.53-.22z"
        fill={colors.mediumGrey}
      />
    </svg>
  );
}

export default UploadIcon;
